import api from '@/api/ks/courseContent/chapter.js'
const state = {
	chapterList: {
		list: [],
		total: 0
	},
	showDetailInfo: {},
	saveId: ''
}
const mutations = {
	showlistState(state, data) {
		state.chapterList = {
			list: data.list,
			total: data.page_info.total_count
		}
	},
	showinfoState(state,data) {
		state.showDetailInfo = data
	},
	createdshowState(state, data) {
		state.saveId = data.id
	}
}
const actions = {
	getShowlist({ commit }, params = {}) {
		api.showlist(params, (res) => {
			commit('showlistState', res)
		})
	},
	getShowinfo({commit}, params = {}) {
		api.showinfo(params, (res) => {
			commit('showinfoState', res)
		})
	},
	async createdshow({commit}, params = {}) {
		try {
			let res = await api.createdshow(params)
			commit('createdshowState', res)
			return 'success'
		} catch (error) {
			return 'error'
		}
		// api.createdshow(params, (res) => {
		// 	commit('createdshowState', res)
		// })
	},
	async showrecall({commit}, params = {}) {
		try {
			let res = await api.showrecall(params)
			return 'success'
		} catch (error) {
			return 'error'
		}
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}